import { render, staticRenderFns } from "./WebhookConfigDoc.vue?vue&type=template&id=0db78384&scoped=true"
import script from "./WebhookConfigDoc.vue?vue&type=script&lang=js"
export * from "./WebhookConfigDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db78384",
  null
  
)

export default component.exports